import React from 'react';
import { Select, Option } from '@sololearnorg/sol';
import useStyles from 'isomorphic-style-loader/useStyles';
import { ConfigMode, IModelConfig, Settings } from '../../../aIChatPlaygroundInterface';
import { Container, i18n } from '../../../../../symphony';
import s from './AIChatPlaygroundSettingModel.scss';
import { aIChatPlaygroundContext } from '../../../aIChatPlaygroundConstants';
import { AIChatPlaygroundService } from '../../../services/AIChatPlaygroundService';

interface IAIChatPlaygroundSettingModelProps {
	setting: IModelConfig
}

export const AIChatPlaygroundSettingModel = ({ setting }: IAIChatPlaygroundSettingModelProps) => {
	useStyles(s);
	const { updateSettings } = Container.take(aIChatPlaygroundContext.value, AIChatPlaygroundService);
	const aiChatSettings = Container.take('global', 'ai-chat-settings') as Settings;
	const modelData = aiChatSettings?.[setting.key];

	if (!modelData) return null;

	return (
		<div className="ai-chat-playground-setting-model">
			<div className="ai-chat-playground-setting-model__label">
				{i18n.t(modelData.title)}
			</div>
			<div className="ai-chat-playground-setting-model__select-container">
				<Select
					defaultValue={setting.value}
					className="ai-chat-playground-setting-model__select"
					disabled={setting.mode !== ConfigMode.Edit}
					onValueChange={(value) => { updateSettings(setting.key, value); }}
				>
					{
						aiChatSettings?.model?.versions.map((version) => (
							<Option value={version} key={version}>
								{version}
							</Option>
						))
					}
				</Select>
			</div>
		</div>
	);
};
